import {
  GET_REVENUE_CENTERS_REQUESTED,
  GET_REVENUE_CENTERS_SUCCEEDED,
  GET_REVENUE_CENTERS_FAILED,
  CREATE_REVENUE_CENTERS_REQUESTED,
  CREATE_REVENUE_CENTERS_SUCCEEDED,
  CREATE_REVENUE_CENTERS_FAILED,
  UPDATE_REVENUE_CENTERS_REQUESTED,
  UPDATE_REVENUE_CENTERS_SUCCEEDED,
  UPDATE_REVENUE_CENTERS_FAILED,
  EDIT_REVENUE_CENTER_REQUESTED,
  EDIT_REVENUE_CENTER_SUCCEEDED,
  EDIT_REVENUE_CENTER_FAILED,
  CLEAR_EDIT_REVENUE_CENTER,
  GET_SERVICE_TYPE_REQUESTED,
  GET_SERVICE_TYPE_SUCCEEDED,
  GET_SERVICE_TYPE_FAILED,
  ADD_SERVICE_TYPE_REQUESTED,
  ADD_SERVICE_TYPE_SUCCEEDED,
  ADD_SERVICE_TYPE_FAILED,
  UPDATE_SERVICE_TYPE_REQUESTED,
  UPDATE_SERVICE_TYPE_SUCCEEDED,
  UPDATE_SERVICE_TYPE_FAILED,
  CLEAR_SERVICE_TYPES_SUCCEEDED,
  GET_LOCATION_SETTINGS_REQUESTED,
  GET_LOCATION_SETTINGS_SUCCEEDED,
  GET_LOCATION_SETTINGS_FAILED,
  ADD_LOCATION_SETTINGS_REQUESTED,
  ADD_LOCATION_SETTINGS_SUCCEEDED,
  ADD_LOCATION_SETTINGS_FAILED,
  UPDATE_LOCATION_SETTINGS_REQUESTED,
  UPDATE_LOCATION_SETTINGS_SUCCEEDED,
  UPDATE_LOCATION_SETTINGS_FAILED,
  CLEAR_LOCATION_SETTINGS_SUCCEEDED,
  GET_MENU_SETTINGS_REQUESTED,
  GET_MENU_SETTINGS_SUCCEEDED,
  GET_MENU_SETTINGS_FAILED,
  ADD_MENU_SETTINGS_REQUESTED,
  ADD_MENU_SETTINGS_SUCCEEDED,
  ADD_MENU_SETTINGS_FAILED,
  UPDATE_MENU_SETTINGS_REQUESTED,
  UPDATE_MENU_SETTINGS_SUCCEEDED,
  UPDATE_MENU_SETTINGS_FAILED,
  CLEAR_MENU_SETTINGS_SUCCEEDED,
  GET_AVAILABILITY_REQUESTED,
  GET_AVAILABILITY_SUCCEEDED,
  GET_AVAILABILITY_FAILED,
  SET_SERVICE_TYPES_WITH_ITEMS,
  CLEAR_SERVICE_TYPES_WITH_ITEMS,
  GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_SUCCEEDED,
  GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_REQUESTED,
  GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_FAILED,
} from './constants'
import DataMapper from '../../utils/dataMapper'
import { keyBy } from 'lodash'

export const defaultState = {
  filters: {
    searchGlobalRevenueCetners: null,
    byServiceTypes: '',
  },
  serviceTypes: {},
}

const state = (state = defaultState, { type, payload }) => {
  switch (type) {
    case GET_REVENUE_CENTERS_REQUESTED:
      return { ...state, isLoading: true }

    case GET_REVENUE_CENTERS_SUCCEEDED: {
      const byId = DataMapper.objectsById(payload)

      return {
        ...state,
        byId,
        isLoading: false,
      }
    }

    case GET_REVENUE_CENTERS_FAILED:
      return { ...state, isLoading: false }

    // paginated and filtered

    case GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_REQUESTED:
      return { ...state, isLoading: true }

    case GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_SUCCEEDED: {
      const { headers, data } = payload

      const total = Number(headers?.total ?? 0)
      const byId = keyBy(data?.stands, 'uuid')

      return {
        ...state,
        pagination: {
          ...state.pagination,
          byId,
          total,
        },
        isLoading: false,
      }
    }

    case GET_FILTERED_AND_PAGINATED_REVENUE_CENTERS_FAILED:
      return { ...state, isLoading: false }

    // create

    case CREATE_REVENUE_CENTERS_REQUESTED:
      return { ...state, isLoading: true }

    case CREATE_REVENUE_CENTERS_SUCCEEDED: {
      const byId = keyBy(payload, 'uuid')

      return {
        ...state,
        isLoading: false,
        pagination: {
          ...state.pagination,
          byId: { ...state.pagination.byId, ...byId },
        },
      }
    }
    case CREATE_REVENUE_CENTERS_FAILED:
      return { ...state, isLoading: true }

    // update

    case UPDATE_REVENUE_CENTERS_REQUESTED:
      return { ...state, isLoading: true }

    case UPDATE_REVENUE_CENTERS_SUCCEEDED: {
      const byId = keyBy(payload, 'uuid')

      return {
        ...state,
        isLoading: false,
        pagination: {
          ...state.pagination,
          byId: { ...state.pagination.byId, ...byId },
        },
      }
    }

    case UPDATE_REVENUE_CENTERS_FAILED:
      return { ...state, isLoading: true }

    // edit

    case EDIT_REVENUE_CENTER_REQUESTED:
      return { ...state, isLoading: true }

    case EDIT_REVENUE_CENTER_SUCCEEDED:
      return { ...state, isLoading: false, editedFormFields: payload }

    case EDIT_REVENUE_CENTER_FAILED:
      return { ...state, isLoading: false }

    // clear

    case CLEAR_EDIT_REVENUE_CENTER:
      return { ...state, editedFormFields: {} }

    // Service Types //

    //GET
    case GET_SERVICE_TYPE_REQUESTED:
      return { ...state.serviceTypes, isLoading: true }

    case GET_SERVICE_TYPE_SUCCEEDED:
      // store for menus, assigned to current revenue center
      const serviceTypes = keyBy(payload, 'uuid')
      return {
        ...state,
        serviceTypes: {
          ...state.serviceTypes,
          byId: { ...state.serviceTypes.byId, ...serviceTypes },
          isLoading: false,
        },
      }

    case GET_SERVICE_TYPE_FAILED:
      return {
        ...state,
        serviceTypes: {
          ...state.serviceTypes,
          err: payload,
        },
      }

    // ADD
    case ADD_SERVICE_TYPE_REQUESTED:
      return {
        ...state,
        serviceTypes: {
          ...state.serviceTypes,
          isLoading: true,
        },
      }

    case ADD_SERVICE_TYPE_SUCCEEDED:
      const newServiceType = payload
      return {
        ...state,
        serviceTypes: {
          ...state.serviceTypes,
          byId: {
            ...state.serviceTypes.byId,
            [newServiceType.uuid]: newServiceType,
          },
        },
      }

    case ADD_SERVICE_TYPE_FAILED:
      return {
        ...state,
        serviceTypes: {
          ...state.serviceTypes,
          err: payload,
        },
      }

    //UPDATE
    case UPDATE_SERVICE_TYPE_REQUESTED:
      return {
        ...state,
        serviceTypes: {
          ...state.serviceTypes,
          isLoading: true,
        },
      }

    case UPDATE_SERVICE_TYPE_SUCCEEDED:
      return {
        ...state,
        serviceTypes: {
          ...state.serviceTypes,
          byId: {
            ...state.serviceTypes.byId,
            [payload.uuid]: payload,
          },
        },
      }

    case UPDATE_SERVICE_TYPE_FAILED:
      return {
        ...state,
        serviceTypes: {
          ...state.serviceTypes,
          err: payload,
        },
      }

    //CLEAR
    case CLEAR_SERVICE_TYPES_SUCCEEDED:
      return {
        ...state,
        serviceTypes: {
          ...state.serviceTypes,
          byId: {},
        },
      }

    // Service Types With items //

    case SET_SERVICE_TYPES_WITH_ITEMS:
      return {
        ...state,
        serviceTypes: {
          ...state.serviceTypes,
          serviceTypesWithItems: payload,
        },
      }

    case CLEAR_SERVICE_TYPES_WITH_ITEMS:
      return {
        ...state,
        serviceTypes: {
          ...state.serviceTypes,
          serviceTypesWithItems: {},
        },
      }

    // Location Settings //

    //GET
    case GET_LOCATION_SETTINGS_REQUESTED:
      return { ...state.locationSettings, isLoading: true }

    case GET_LOCATION_SETTINGS_SUCCEEDED:
      const locationSettings = keyBy(payload, 'uuid')
      return {
        ...state,
        locationSettings: {
          ...state.locationSettings,
          locationSettingsData: locationSettings,
          isLoading: false,
        },
      }

    case GET_LOCATION_SETTINGS_FAILED:
      return {
        ...state,
        locationSettings: {
          ...state.locationSettings,
          err: payload,
        },
      }

    // ADD
    case ADD_LOCATION_SETTINGS_REQUESTED:
      return {
        ...state,
        locationSettings: {
          ...state.locationSettings,
          isLoading: true,
        },
      }

    case ADD_LOCATION_SETTINGS_SUCCEEDED:
      const locationSettingsData = payload
      return {
        ...state,
        locationSettings: {
          ...state.locationSettings,
          locationSettingsData,
          isLoading: false,
        },
      }

    case ADD_LOCATION_SETTINGS_FAILED:
      return {
        ...state,
        locationSettings: {
          ...state.locationSettings,
          err: payload,
          loading: false,
        },
      }

    //UPDATE
    case UPDATE_LOCATION_SETTINGS_REQUESTED:
      return {
        ...state,
        locationSettings: {
          ...state.locationSettings,
          isLoading: true,
        },
      }

    case UPDATE_LOCATION_SETTINGS_SUCCEEDED:
      return {
        ...state,
        locationSettings: {
          ...state.locationSettings,
          locationSettingsData: payload,
          loading: false,
        },
      }

    case UPDATE_LOCATION_SETTINGS_FAILED:
      return {
        ...state,
        locationSettings: {
          ...state.locationSettings,
          err: payload,
          loading: false,
        },
      }

    //CLEAR
    case CLEAR_LOCATION_SETTINGS_SUCCEEDED:
      return {
        ...state,
        locationSettings: {
          ...state.locationSettings,
          locationSettingsData: {},
        },
      }

    // Menu Settings //

    //GET
    case GET_MENU_SETTINGS_REQUESTED:
      return { ...state.locationSettings, isLoading: true }

    case GET_MENU_SETTINGS_SUCCEEDED:
      const menuSettings = keyBy(payload, 'uuid')
      return {
        ...state,
        menuSettings: {
          ...state.menuSettings,
          menuSettingsData: menuSettings,
          isLoading: false,
        },
      }

    case GET_MENU_SETTINGS_FAILED:
      return {
        ...state,
        menuSettings: {
          ...state.menuSettings,
          err: payload,
        },
      }

    // ADD
    case ADD_MENU_SETTINGS_REQUESTED:
      return {
        ...state,
        menuSettings: {
          ...state.menuSettings,
          isLoading: true,
        },
      }

    case ADD_MENU_SETTINGS_SUCCEEDED:
      const menuSettingsDataById = keyBy(payload, 'uuid')
      return {
        ...state,
        menuSettings: {
          ...state.menuSettings,
          menuSettingsData: {
            ...state?.menuSettings?.menuSettingsData,
            ...menuSettingsDataById,
          },
          isLoading: false,
        },
      }

    case ADD_MENU_SETTINGS_FAILED:
      return {
        ...state,
        menuSettings: {
          ...state.menuSettings,
          err: payload,
          loading: false,
        },
      }

    //UPDATE
    case UPDATE_MENU_SETTINGS_REQUESTED:
      return {
        ...state,
        menuSettings: {
          ...state.menuSettings,
          isLoading: true,
        },
      }

    case UPDATE_MENU_SETTINGS_SUCCEEDED:
      return {
        ...state,
        menuSettings: {
          ...state.menuSettings,
          menuSettingsData: payload,
          loading: false,
        },
      }

    case UPDATE_MENU_SETTINGS_FAILED:
      return {
        ...state,
        menuSettings: {
          ...state.menuSettings,
          err: payload,
          loading: false,
        },
      }

    //CLEAR
    case CLEAR_MENU_SETTINGS_SUCCEEDED:
      return {
        ...state,
        menuSettings: {
          ...state.menuSettings,
          menuSettingsData: {},
        },
      }

    //Availability //
    case GET_AVAILABILITY_REQUESTED:
      return {
        ...state,
        availability: {
          ...state.availability,
          loading: true,
        },
      }

    case GET_AVAILABILITY_SUCCEEDED:
      const byId = keyBy(payload, 'uuid')

      return {
        ...state,
        availability: {
          ...state.availability,
          loading: false,
          byId,
        },
      }

    case GET_AVAILABILITY_FAILED:
      return {
        ...state,
        availability: {
          ...state.availability,
          error: payload,
        },
      }

    default:
      return state
  }
}

export default state
